import React from 'react';
import { Redirect } from 'react-router-dom';
import FuseUtils from '@fuse/utils';
import authConfig from 'app/main/auth/auth-configs';
import aiaasConfigs from 'app/main/aiaas/aiaas-configs';
import publicConfigs from 'app/main/public/public-configs';

const routeConfigs = [authConfig, ...publicConfigs, ...aiaasConfigs];

const routes = [
	...FuseUtils.generateRoutesFromConfigs(routeConfigs),
	{
		path: '/',
		component: () => <Redirect to="/services" />
	},
	{
		path: '/free/services',
		component: () => <Redirect to="/services" />
	}
];

export default routes;
